<div class="flex flex-col gap-3 sm:gap-4">
  <!-- Price Display Section - Only show when product has a valid price -->
  <div *ngIf="getCurrentPrice() > 0" class="flex flex-col gap-2 sm:gap-3">
    <!-- Pricing Display -->
    <div class="flex flex-col gap-2">
             <!-- Price with VAT toggle - Responsive layout -->
       <div class="flex flex-col gap-2">
         <!-- Current price and VAT toggle on same row -->
         <div class="flex items-center gap-2 sm:gap-4">
           <h1 class="text-lg sm:text-xl font-bold text-gray-900 m-0">
              <span translate="no" class="notranslate">{{ getCurrentPrice() | appendCurrency }}</span>
           </h1>
           
                      <!-- VAT toggle - Beside current price -->
           <div class="flex items-center gap-1 sm:gap-2">
            <span class="text-xs font-medium whitespace-nowrap" [class.text-gray-500]="!showPriceWithVAT" [class.text-orange-600]="showPriceWithVAT">{{ 'brutto (z VAT)' | translate }}</span>
            <button
              (click)="toggleVAT()"
              class="relative inline-flex h-5 w-9 sm:h-6 sm:w-12 items-center rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 shadow-inner"
              [class.bg-orange-500]="showPriceWithVAT"
              [class.bg-gray-300]="!showPriceWithVAT"
              [title]="'Przełącz wyświetlanie cen brutto i netto' | translate"
            >
              <span
                class="inline-block h-4 w-4 sm:h-5 sm:w-5 transform rounded-full bg-white transition-all duration-300 shadow-md"
                [class.translate-x-5]="showPriceWithVAT"
                [class.sm:translate-x-7]="showPriceWithVAT"
                [class.translate-x-0]="!showPriceWithVAT"
              ></span>
            </button>
            <span class="text-xs font-medium whitespace-nowrap" [class.text-gray-500]="showPriceWithVAT" [class.text-orange-600]="!showPriceWithVAT">{{ 'netto (bez VAT)' | translate }}</span>
          </div>
        </div>
        
                 <!-- Old price information below -->
         <span *ngIf="discountRate > 0" class="text-sm text-gray-500">
           <span class="text-gray-600">{{ 'Najniższa cena z 30 dni przed obniżką:' | translate }}</span>
           <span translate="no" class="notranslate line-through ml-1">{{ getOriginalPrice() | appendCurrency }}</span>
           <span class="ml-2 text-green-600 font-medium">(-{{ discountRate }}%)</span>
         </span>
    </div>
  </div>
  <!-- Shipping Info - Only show when product has a valid price -->
  <div *ngIf="getCurrentPrice() > 0" class="flex flex-col gap-2">
    <button *ngIf="deliveryPrice !== 0" #shippingTrigger type="button" class="flex w-fit items-start sm:items-center gap-2 text-left cursor-pointer hover:text-orange-600 underline hover:no-underline transition-colors duration-200" (click)="openShippingPopup(shippingTrigger)" [title]="'Kliknij, aby poznać koszty dostawy' | translate" aria-haspopup="dialog" [attr.aria-expanded]="showShippingPopup">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4 sm:w-5 sm:h-5 text-orange-500 flex-shrink-0 mt-0.5 sm:mt-0">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0v-3.75m3 3.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0v-3.75m-3 3.75V15a2.25 2.25 0 012.25-2.25h1.5m-9 0V12A2.25 2.25 0 0112.75 9.75h1.5M15 9.75v-3.75M15 6V3.75A1.5 1.5 0 0013.5 2.25h-3A1.5 1.5 0 009 3.75V6" />
      </svg>
      <span class="text-xs sm:text-sm text-gray-600 leading-relaxed">
        {{ 'Do ceny należy doliczyć koszt dostawy' | translate }}
      </span>
    </button>

    <!-- Delivery Time -->
    <button type="button" #deliveryTrigger class="flex w-fit items-start sm:items-center gap-2 text-left cursor-pointer hover:text-orange-600 underline hover:no-underline transition-colors duration-200" (click)="openDeliveryPopup(deliveryTrigger)" [title]="'Kliknij, aby poznać szczegóły dostawy' | translate" aria-haspopup="dialog" [attr.aria-expanded]="showDeliveryPopup">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4 sm:w-5 sm:h-5 text-orange-500 flex-shrink-0 mt-0.5 sm:mt-0">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
      </svg>
      <span class="text-xs sm:text-sm text-gray-600 leading-relaxed">
        {{ getDeliveryTimeText() | translate }}
      </span>
    </button>
  </div>

  <!-- Shipping Costs Popup -->
  <div
    *ngIf="showShippingPopup"
    class="product-popup-backdrop fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/45 p-4 backdrop-blur-sm"
    [class.product-popup-closing]="isShippingPopupClosing"
    (click)="closeShippingPopup()"
  >
    <div
      #shippingDialog
      role="dialog"
      aria-modal="true"
      aria-labelledby="shipping-costs-title"
      class="product-popup-dialog w-full max-w-lg overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-2xl shadow-slate-950/20"
      [class.product-popup-closing]="isShippingPopupClosing"
      (keydown)="onPopupKeydown($event, 'shipping')"
      (click)="$event.stopPropagation()"
    >
      <div class="flex items-center justify-between border-b border-gray-100 px-5 py-4 sm:px-6">
        <div class="flex items-center gap-3">
          <span class="flex h-9 w-9 items-center justify-center rounded-full bg-orange-50 text-orange-600">
            <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
          </span>
          <h3 id="shipping-costs-title" class="text-lg font-semibold text-gray-900">
            {{ 'KOSZTY DOSTAWY' | translate }}
          </h3>
        </div>
        <button type="button" (click)="closeShippingPopup()"
          class="rounded-lg p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
          [attr.aria-label]="'Zamknij' | translate">
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="space-y-4 px-5 py-5 text-sm leading-6 text-gray-600 sm:px-6 sm:py-6">
        <p>
          {{ 'Gwarantujemy' | translate }} <strong class="font-semibold text-green-700">{{ 'bezpłatną dostawę' | translate }}</strong> {{ 'przesyłek przy wartości zamówienia wynoszącej' | translate }}
          <strong class="font-semibold text-gray-900">{{ shippingService.formatFreeShippingAmount(shippingService.getFreeShippingThreshold('PL'), 'PL') }}</strong>
          {{ 'w Polsce lub' | translate }}
          <strong class="font-semibold text-gray-900">{{ shippingService.formatFreeShippingAmount(shippingService.getFreeShippingThreshold('DE'), 'DE') }}</strong>
          {{ 'w Europie i innych lokalizacjach (bez VAT).' | translate }}
        </p>
        <p class="rounded-xl bg-gray-50 px-4 py-3">
          {{ 'Poniżej wskazanego progu koszty dostawy są obliczane na podstawie adresu dostawy.' | translate }}
        </p>
        <p class="rounded-xl border border-orange-100 bg-orange-50/70 px-4 py-3 text-gray-700">
          <strong class="font-semibold">{{ 'Uwaga: bezpłatna dostawa dotyczy wyłącznie przesyłek paczkowych. Nie obejmuje przesyłek paletowych.' | translate }}</strong>
        </p>
      </div>
      <div class="flex justify-end border-t border-gray-100 bg-gray-50/70 px-5 py-4 sm:px-6">
        <button type="button" (click)="closeShippingPopup()"
          class="rounded-lg bg-orange-600 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2">
          {{ 'Rozumiem' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Delivery Time Popup -->
  <div
    *ngIf="showDeliveryPopup"
    class="product-popup-backdrop fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/45 p-4 backdrop-blur-sm"
    [class.product-popup-closing]="isDeliveryPopupClosing"
    (click)="closeDeliveryPopup()"
  >
    <div
      #deliveryDialog
      role="dialog"
      aria-modal="true"
      aria-labelledby="delivery-time-title"
      class="product-popup-dialog w-full max-w-lg max-h-[90vh] overflow-y-auto rounded-2xl border border-gray-100 bg-white shadow-2xl shadow-slate-950/20"
      [class.product-popup-closing]="isDeliveryPopupClosing"
      (keydown)="onPopupKeydown($event, 'delivery')"
      (click)="$event.stopPropagation()"
    >
      <div class="sticky top-0 flex items-center justify-between border-b border-gray-100 bg-white px-5 py-4 sm:px-6">
        <div class="flex items-center gap-3">
          <span class="flex h-9 w-9 items-center justify-center rounded-full bg-orange-50 text-orange-600">
            <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </span>
          <h3 id="delivery-time-title" class="text-lg font-semibold text-gray-900">
            {{ 'Czas dostawy' | translate }}
          </h3>
        </div>
        <button type="button" (click)="closeDeliveryPopup()"
          class="rounded-lg p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
          [attr.aria-label]="'Zamknij' | translate">
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="space-y-4 px-5 py-5 text-sm leading-6 text-gray-600 sm:px-6 sm:py-6">
        <p>
          {{ 'Podany czas dostawy w' | translate }} <strong>{{ 'dniach roboczych' | translate }}</strong> {{ 'nie obejmuje weekendów ani dni świątecznych. Termin dostawy zależy od wybranej metody płatności.' | translate }}
        </p>
        
        <div class="space-y-3">
          <div class="rounded-xl border border-gray-100 bg-gray-50 px-4 py-3">
            <p class="mb-1 font-semibold text-gray-900">{{ 'Płatność z góry:' | translate }}</p>
            <p>{{ 'Przesyłka jest dostarczana w dni robocze (od poniedziałku do piątku) po otrzymaniu płatności.' | translate }}</p>
          </div>
          
          <div class="rounded-xl border border-gray-100 bg-gray-50 px-4 py-3">
            <p class="mb-1 font-semibold text-gray-900">{{ 'Faktura, PayPal, Przelewy24, karta płatnicza:' | translate }}</p>
            <p>{{ 'Przesyłka jest dostarczana w dni robocze (od poniedziałku do piątku) po otrzymaniu zamówienia.' | translate }}</p>
          </div>
          
          <div class="rounded-xl border border-orange-100 bg-orange-50/70 px-4 py-3">
            <p class="mb-1 font-semibold text-gray-900">{{ 'Produkty modyfikowane:' | translate }}</p>
            <p>{{ 'W przypadku produktów modyfikowanych zgodnie z Twoimi wymaganiami (np. przez haft lub nadruk) termin dostawy ustalamy indywidualnie.' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="sticky bottom-0 flex justify-end border-t border-gray-100 bg-gray-50/70 px-5 py-4 sm:px-6">
        <button type="button" (click)="closeDeliveryPopup()"
          class="rounded-lg bg-orange-600 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2">
          {{ 'Rozumiem' | translate }}
        </button>
      </div>
    </div>
  </div>
